import { createSlice } from '@reduxjs/toolkit';
import BaseError from '../../../utils/base-error';
import { CateringEventPageState } from './catering-event-page-state';
import { CateringEventPageActions } from './actions';
import { createCateringEventFromGetCateringEventBySlugApiResponse } from '../utils';

const initialState: CateringEventPageState = {
    loaded: false,
    errors: [],
};

export const cateringEventPageSlice = createSlice({
    name: 'cateringEventPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            CateringEventPageActions.getCateringEventBySlug.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const result = createCateringEventFromGetCateringEventBySlugApiResponse(
                            response.data,
                        );

                        state.cateringEvent = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});
